const l = {
  name: "Bluetooth",
  dimensions: { width: 22, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 22.1 40" style="enable-background:new 0 0 22.1 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9.7,0h2.4l10,10l-10,10l10,10l-10,10H9.7V22.4l-8.3,8.3L0,29.3L9.3,20L0,10.7l1.4-1.4l8.3,8.3V0z M11.7,22.4
			v15.2l7.6-7.6L11.7,22.4z M11.7,17.6l7.6-7.6l-7.6-7.6V17.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Bluetooth
};
